module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.spinShow) ? _c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('menu-aside'), _vm._v(" "), (_vm.hasJiuJing) ? _c('ConfirmOrders') : _vm._e(), _vm._v(" "), _c('header', {
    staticClass: "header"
  }, [(!_vm.hideBizLines) ? _c('Select', {
    staticClass: "bizline-select",
    on: {
      "on-change": _vm.bizLineChanged
    },
    model: {
      value: (_vm.currentBizLine),
      callback: function($$v) {
        _vm.currentBizLine = $$v
      },
      expression: "currentBizLine"
    }
  }, _vm._l((_vm.authBizLines), function(bizLine) {
    return _c('Option', {
      key: bizLine.value,
      attrs: {
        "value": bizLine.value
      }
    }, [_vm._v(_vm._s(bizLine.name))])
  })) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "account-actions"
  }, [_c('Dropdown', {
    attrs: {
      "placement": "bottom-end",
      "trigger": "click"
    },
    on: {
      "on-click": _vm.dropDownMenuClicked
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.userName) + "\n          "), _c('Icon', {
    attrs: {
      "type": "arrow-down-b"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    slot: "list"
  }, _vm._l((_vm.userMenus), function(menu) {
    return _c('DropdownItem', {
      key: menu.id,
      attrs: {
        "name": menu.id
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_vm._v(_vm._s(menu.name))])])
  }))], 1), _vm._v(" "), _c('span', {
    staticClass: "account-type"
  }, [_vm._v(_vm._s(_vm.accountType))]), _vm._v(" "), _c('span', {
    staticClass: "msg-center"
  }, [_c('msg-center'), _vm._v(" "), _c('voice-notification')], 1), _vm._v(" "), _c('span', {
    staticClass: "presale-chat",
    attrs: {
      "title": "售前服务"
    },
    on: {
      "click": _vm.openPreSale
    }
  }, [_c('Icon', {
    attrs: {
      "type": 'turbo-ui-headset'
    }
  })], 1), _vm._v(" "), (_vm.hasWalletList) ? _c('span', {
    staticClass: "my-wallet",
    attrs: {
      "title": "我的钱包"
    },
    on: {
      "click": _vm.navToWalletList
    }
  }, [_c('Icon', {
    attrs: {
      "type": 'turbo-ui-wallet'
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "work-space"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cae76352","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Main.vue
// module id = 930
// module chunks = 0